<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="11">
        <span style="font-weight: bold; font-size: 18px; color: var(--qs-primary-color)">
          全部用户
        </span>
        <el-form class="qs-padding-top-10" inline :model="leftSearchData">
          <el-form-item>
            <el-input
              placeholder="账号/姓名"
              clearable
              prefix-icon="el-icon-search"
              v-model="leftSearchData.searchInputValue"
              style="width: 250px"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="leftChangeAndSearch"
            >
              搜索
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="leftSearchRes && leftSearchRes.data ? leftSearchRes.data : []"
          stripe
          ref="leftRefsTable"
          @sort-change="leftSortChange"
          @selection-change="leftHandleSelectionChange"
          max-height="300px"
        >
          <el-table-column
            type="selection"
            :selectable="selectableFun"
            width="55"
          >
          </el-table-column>
          <el-table-column
            prop="account"
            label="账号"
            width="100"
            header-align="center"
            align="left"
            sortable="custom"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            width="100"
            header-align="center"
            align="left"
            sortable="custom"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="organization.name"
            label="门诊部"
            width="150"
            align="left"
            header-align="left"
            sortable="custom"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="leftSearchRes && leftSearchRes.pageInfo"
          @current-change="leftHandleCurrentChange"
          :current-page="leftSearchRes.pageInfo.page"
          :page-size="leftSearchRes.pageInfo.pageSize"
          layout="total, prev, pager, next "
          :total="leftSearchRes.total"
        >
        </el-pagination>
      </el-col>
      <el-col :span="2">
        <div style="padding-top: 100px">
          <span v-if="leftList.length > 0">已选 {{ leftList.length }}</span>
          <el-button
            type="primary"
            @click="addUserToRole"
          >添加</el-button>
        </div>
        <div style="padding-top: 30px">
          <span v-if="rightList.length > 0">已选 {{ rightList.length }}</span>
          <el-button
            type="primary"
            @click="cancelUserFromRole"
          >移除</el-button>
        </div>
      </el-col>
      <el-col :span="11">
        <span style="font-weight: bold; font-size: 18px; color: var(--qs-primary-color)">
          已分配
        </span>
        <el-form class="qs-padding-top-10" inline :model="rightSearchData">
          <el-form-item>
            <el-input
              placeholder="账号/姓名"
              clearable
              prefix-icon="el-icon-search"
              v-model="rightSearchData.searchInputValue"
              style="width: 250px"
            >
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="rightChangeAndSearch"
            >
              搜索
            </el-button>
          </el-form-item>
        </el-form>
        <el-table
          :data="
            rightSearchRes && rightSearchRes.data ? rightSearchRes.data : []
          "
          stripe
          ref="rightRefsTable"
          @sort-change="rightSortChange"
          @selection-change="rightHandleSelectionChange"
          max-height="300px"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column
            prop="account"
            label="账号"
            width="100"
            header-align="center"
            align="left"
            sortable="custom"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="name"
            label="姓名"
            width="100"
            header-align="center"
            align="left"
            sortable="custom"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="organization.name"
            label="门诊部"
            width="150"
            align="left"
            header-align="left"
            sortable="custom"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table>
        <el-pagination
          v-if="rightSearchRes && rightSearchRes.pageInfo"
          @current-change="rightHandleCurrentChange"
          :current-page="rightSearchRes.pageInfo.page"
          :page-size="rightSearchRes.pageInfo.pageSize"
          layout="total, prev, pager, next "
          :total="rightSearchRes.total"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "UserTransferForRole",
  props: {
    roleId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      leftSearchData: {
        searchInputValue: null,
      },
      leftSearchParam: {
        quickSearchInfoList: [
          {
            columns: ["account", "name"],
            quickSearchValue: null,
          },
        ],
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      leftSearchRes: {},
      rightSearchData: {
        searchInputValue: null,
      },
      rightSearchParam: {
        quickSearchInfoList: [
          {
            columns: ["user.account", "user.name"],
            quickSearchValue: null,
          },
        ],
        roleId: null,
        pageInfo: {
          page: 1,
          pageSize: 20,
        },
        sortInfo: null,
      },
      rightSearchRes: {},
      leftList: [],
      rightList: [],
    };
  },
  methods: {
    selectableFun(row, index) {
      return !row.disabled;
    },
    leftSortChange(val) {
      this.leftSearchParam.sortInfo =
        val && val.order
          ? {
              columnName: val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.leftSearch(true, {
        showSuccessMessage: true,
      });
    },
    leftHandleSelectionChange(val) {
      this.leftList = val;
    },
    leftHandleCurrentChange(val) {
      this.leftSearchParam.pageInfo.page = val;
      this.leftSearch(false, {
        showSuccessMessage: true,
      });
    },
    leftChangeAndSearch() {
      this.leftSearchParam.quickSearchInfoList[0].quickSearchValue =
        this.leftSearchData.searchInputValue;
      this.leftSearch(true, {
        showSuccessMessage: true,
      });
    },
    async leftSearch(init, args) {
      if (init) {
        this.leftSearchParam.pageInfo.page = 1;
      }
      let requestRes = await this.$api.user_findPageForSelect(
        this.leftSearchParam,
        args
      );
      if (requestRes && requestRes.success) {
        let list = requestRes.data;
        if (list.length > 0) {
          let checkResult = await this.$api.sysRole_checkDistribute(
            this.roleId,
            list.map((item) => {
              return item.id;
            })
          );
          if (checkResult && checkResult.success && checkResult.data) {
            let hasIdList = checkResult.data;
            list = list.map((item) => {
              return {
                ...item,
                disabled: hasIdList.indexOf(item.id) > -1,
              };
            });
          }
        }
        this.leftSearchRes = {
          ...requestRes,
          data: list,
        };
        this.$nextTick(() => {
          this.$refs.leftRefsTable.doLayout();
        });
      }
      if (requestRes.pageCount == 0) {
        this.leftSearchRes = null;
      }
    },
    rightSortChange(val) {
      this.rightSearchParam.sortInfo =
        val && val.order
          ? {
              columnName: "user." + val.prop,
              order: val.order.replace("ending", "").toUpperCase(),
            }
          : null;
      this.rightSearch(true, {
        showSuccessMessage: true,
      });
    },
    rightHandleCurrentChange(val) {
      this.rightSearchParam.pageInfo.page = val;
      this.rightSearch(false, {
        showSuccessMessage: true,
      });
    },
    rightHandleSelectionChange(val) {
      this.rightList = val;
    },
    rightChangeAndSearch() {
      this.rightSearchParam.quickSearchInfoList[0].quickSearchValue =
        this.rightSearchData.searchInputValue;
      this.rightSearch(true, {
        showSuccessMessage: true,
      });
    },
    async rightSearch(init, args) {
      if (init) {
        this.rightSearchParam.pageInfo.page = 1;
      }
      this.rightSearchParam.roleId = this.roleId;
      let requestRes = await this.$api.sysRole_findRoleUserPage(
        this.rightSearchParam,
        args
      );
      if (requestRes && requestRes.success) {
        let list = requestRes.data;
        if (list && list.length > 0) {
          list = list.map((d) => {
            return d.user;
          });
        }
        this.rightSearchRes = { ...requestRes, data: list };
        this.$nextTick(() => {
          this.$refs.rightRefsTable.doLayout();
        });
      }
      if (requestRes.pageCount == 0) {
        this.rightSearchRes = null;
      }
    },
    async addUserToRole() {
      let requestRes = await this.$api.sysRole_addUserToRole(
        this.leftList.map((item) => {
          return {
            sysRoleId: this.roleId,
            userId: item.id,
          };
        })
      );
      if (requestRes && requestRes.success) {
        await this.leftSearch();
        await this.rightSearch();
        this.$emit("addSuccess");
      }
    },
    async cancelUserFromRole() {
      let requestRes = await this.$api.sysRole_cancelUserFromRole(
        this.rightList.map((item) => {
          return {
            sysRoleId: this.roleId,
            userId: item.id,
          };
        })
      );
      if (requestRes && requestRes.success) {
        await this.leftSearch();
        await this.rightSearch();
        this.$emit("cancelSuccess");
      }
    },
  },
  mounted() {
    this.leftSearch(true);
    this.rightSearch(true,{showFailMessage:false});
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/UserTransferForRole.vue